import React from 'react';
import styled from 'styled-components';
import { TrevorComponent } from '../../types';

export type LabelButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon?: React.ReactNode;
};

export const LabelButtonRaw: TrevorComponent<LabelButtonProps> = ({
  children,
  icon,
  className,
  dataTestId,
  ...props
}) => (
  <button className={className} data-testid={dataTestId} {...props}>
    {icon && <i>{icon}</i>}
    <span>{children}</span>
  </button>
);

export const LabelButton = styled(LabelButtonRaw)`
  --v-padding: 4px;
  --h-padding: calc(var(--v-padding) * 1.5);
  --border: 1px solid #e8e8e8;

  align-items: center;
  background-color: #f8f8f8;
  border: var(--border);
  border-radius: 3px;
  color: #666;
  cursor: pointer;
  display: flex;
  padding: 0;

  &:disabled {
    cursor: initial;
  }

  &:not(:disabled):hover {
    background-color: #eeeeee; // TODO: Clarify with Erin
  }

  span {
    font-size: 12px;
    line-height: 18px;
    padding: var(--v-padding) var(--h-padding);
  }

  i {
    align-items: center;
    display: flex;
    height: 100%;
    padding-inline: var(--h-padding);
  }

  i + span {
    border-left: var(--border);
  }
`;
